var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dense: "",
                    elevation: "0",
                    dark: ""
                  }
                },
                [_c("span", [_vm._v("Sow Pig Preferences")])]
              ),
              _c("edit-sow-pig-preferences")
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dense: "",
                    elevation: "0",
                    dark: ""
                  }
                },
                [_c("span", [_vm._v("List")])]
              ),
              _c("table-sow-pig")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }